import { Command } from "./Command";
export class UploadCommand extends Command {
    constructor(method, url, progress = null) {
        super(method, url);
        this.progress = progress;
        this.configure = (config, data) => {
            config.onUploadProgress = this.progress;
            config.headers["content-type"] = "multipart/form-data";
            let form = new FormData();
            for (let key in data) {
                // データが複数かつファイルの場合（複数ファイル）
                if (Array.isArray(data[key])) {
                    if (data[key][0] instanceof File) {
                        for (let d in data[key]) {
                            form.append(key, data[key][d]);
                        }
                        // データ複数かつオブジェクト
                    }
                    else if (typeof data[key][0] === "object") {
                        for (let d in data[key]) {
                            let index = data[key].indexOf(data[key][d]);
                            for (let p in data[key][d]) {
                                // eslint-disable-next-line max-depth
                                if (data[key][d][p] instanceof File) {
                                    // オブジェクトの中にファイルプロパティがある
                                    form.append(`${key}[${index}].${p}`, data[key][d][p]);
                                }
                                else if (typeof data[key][d][p] === "object") {
                                    // オブジェクトの中に更にオブジェクトがある（入れ子になっている）
                                    // eslint-disable-next-line max-depth
                                    for (let dp in data[key][d][p]) {
                                        let dpIndex = data[key][d][p].indexOf(data[key][d][p][dp]);
                                        // eslint-disable-next-line max-depth
                                        if (typeof data[key][d][p][dp] === "object") {
                                            // eslint-disable-next-line max-depth
                                            for (let dpl in data[key][d][p][dp]) {
                                                form.append(`${key}[${index}].${p}[${dpIndex}].${dpl}`, data[key][d][p][dp][dpl]);
                                            }
                                        }
                                        else {
                                            form.append(`${key}[${index}].${p}[${dpIndex}].${dp}`, data[key][d][p][dp]);
                                        }
                                    }
                                }
                                else {
                                    form.append(`${key}[${index}].${p}`, data[key][d][p]);
                                }
                            }
                        }
                        // データ複数
                    }
                    else {
                        for (let d in data[key]) {
                            form.append(key + "[]", data[key][d]);
                        }
                    }
                    // 単数オブジェクトの場合(ファイルではない場合)
                }
                else if (typeof data[key] === "object" && !(data[key] instanceof File)) {
                    for (let d in data[key]) {
                        form.append(`${key}[${d}]`, data[key][d]);
                    }
                }
                else {
                    form.append(key, data[key]);
                }
            }
            config.data = form;
        };
    }
    progress = null;
}
